module.exports = __webpack_public_path__ + "static/media/star.462f3eaa.svg";